export { default } from "./customer-profile-individual-form";